import { render, staticRenderFns } from "./OverViewAddons.vue?vue&type=template&id=0910913e&"
import script from "./OverViewAddons.vue?vue&type=script&lang=js&"
export * from "./OverViewAddons.vue?vue&type=script&lang=js&"
import style0 from "./OverViewAddons.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports